jQuery(document).ready(function($) {
  // ----------------------------- FUNZIONI GRIGLIE ISOTOPE

  // ISOTOPE STANDARD / doppio filtro, tramite select o search
  function rw_iso(isoContainer, filterValue){
    var qsRegex;

    // https://codepen.io/desandro/pen/mCdbD
    var $gridStandard = $(isoContainer).isotope({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.iso-item',
      transitionDuration: 0,  // elimina le transizioni
      isResizeBound: false,    // elimina i delay nei riallineamenti
      filter: function() {
        var $this = $(this);
        var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
        var filterResult = filterValue ? $this.is( filterValue ) : true;
        return searchResult && filterResult;
      }
    })
    function searchFilter() {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $gridStandard.isotope();
    }

    // use value of search field to filter
    var $quicksearch = $('#quicksearch').keyup( debounce( searchFilter ) );

    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
      var timeout;
      return function debounced() {
        if ( timeout ) {
          clearTimeout( timeout );
        }
        function delayed() {
          fn();
          timeout = null;
        }
        setTimeout( delayed, threshold || 100 );
      }
    }

    img_load_refresh($gridStandard);

  }

  // ISOTOPE FITROWS
  function rw_iso_fit(isoFitContainer){
    var $gridFit = $(isoFitContainer).isotope({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.iso-item',
      transitionDuration: 0,  // elimina le transizioni
      isResizeBound: false,   // elimina i delay nei riallineamenti
      layoutMode: 'fitRows'
    })
    img_load_refresh($gridFit);
  }

  // REFRESH DOPO CARICAMENTO IMMAGINI
  function img_load_refresh($grid){
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });
  }

  // DESTROY ISO
  function destroy_layout(classe){
    $(classe).isotope('destroy')
  }


  // ----------------------------- INIZIALIZZO LE GRIGLIE ISOTOPE

  rw_iso('.rw-iso');

  // ----------------------------- FILTRI ISOTOPE - usati in rassegna stampa
  $('.iso-filter span').on( 'click', function() {
    $('.iso-filter span').removeClass('attivo');
    var filterValue = $(this).attr('data-filter');
    $('.rw-iso-fit').isotope({ filter: filterValue });
    $(this).toggleClass('attivo');
  });


  // ----------------------------- FILTRI ISOTOPE - MYPLUST / Downloads

  $('.iso-filter-download').on( 'change', function() {

    // Azzero gli altri select quando ne seleziono uno
    var questoFiltro = $(this).attr('id');
    var filtroAttivo = localStorage['idSelectFilter'];
    if( filtroAttivo !== questoFiltro ){
      localStorage['idSelectFilter'] = questoFiltro;
      $('#' + filtroAttivo ).prop('selectedIndex',0);
    }

    // prendo il valore del filtro dal select e lo mando a isotope
    var filterValue = this.value;
    // $('.rw-iso').isotope({ filter: filterValue });
    $('select').trigger('chosen:updated');
    rw_iso('.rw-iso', filterValue);

  });


    //---------------------------------------------------------
  // RESPONSIVE AL CARICAMENTO ( fire unico )
  if ($(window).width() < 576) {        // --- xs

  }
  else if ($(window).width() < 768) {   // --- sm
    rw_iso('.rw-iso-fit');
  }
  else if ($(window).width() < 992) {   // --- md

  }
  else if ($(window).width() < 1200) {  // --- lg

  }
  else  {                               // --- xl
    rw_iso_fit('.rw-iso-fit');
  }


      // https://stackoverflow.com/questions/15859018/jquery-trigger-function-when-window-width-matches-any-value-in-array
    // FUNZIONI AL BREAKPOINT
  // fire unico allo scattare del breakpoint
  var $wind = $(window),
      breakpoints = [576, 768, 992, 1200],
      currentBreakpoint = 0;


  var breakpointHit = function(breakpoint) {

      if(breakpoint == 1200 ){          // --- lg
        rw_iso_fit('.rw-iso-fit');
      } else if (breakpoint == 992 ){   // --- md
        destroy_layout('.rw-iso-fit');
        rw_iso_fit('.rw-iso-fit');
      } else if (breakpoint == 768 ){   // --- sm
        destroy_layout('.rw-iso-fit');
        rw_iso('.rw-iso-fit');
      } else if (breakpoint == 576 ){   // --- xs
        rw_iso('.rw-iso-fit');
      }
  }

  $wind.resize(function() {
  	var i$, len$; window_w = $wind.width();
      for (i$ = 0, len$ = breakpoints.length; i$ < len$; i$++) {
          var testPoint = breakpoints[i$];
          if (window_w < testPoint) {
               if (testPoint == currentBreakpoint)
                   break;
               currentBreakpoint = testPoint;
               breakpointHit(testPoint);
               break;
          }
      }
  });

    //---------------------------------------------------------
  // FILTER














    //---------------------------------------------------------
  // ON RESIZE
  $(window).resize(function() {

    rw_iso('.rw-iso');

    if ($(window).width() < 768) {   // --- sm
      rw_iso('.rw-iso-fit');
    }
    else  {                               // --- xl
      rw_iso_fit('.rw-iso-fit');
    }

  });


});
